import { FC } from "react";
import Script from "next/script";
import { Wrapper } from "./FaceBook.styled";

interface Props {
  url?: string;
}

const FaceBook: FC<Props> = ({ url }) => {
  return (
    <>
      <Script
        async
        defer
        src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2"
      ></Script>
      <Wrapper>
        <div className="fb-post" data-href={url} />
      </Wrapper>
    </>
  );
};

export default FaceBook;
